import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, colors } from '../../theme'

const DSNotificationsStyles: IStyles = {
    notificationsComponent: {
        [mediaCSS.tabMini]: {
            paddingTop: 60,
        },
    },
    wrapper: {
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
        overflow: 'hidden',
    },
    unitsHeader: {
        fontWeight: 700,
        borderTop: `1px solid ${colors.grey}`,
    },
    checkboxHeader: {
        marginLeft: 34,
    },
    listWrapper: {
        position: 'relative',
    },
    checkbox: {
        //display: 'flex',
        minWidth: 70,
        paddingLeft: 14,
    },
    handle: {
        marginRight: 20,
    },
    unitName: {},
    floorNumber: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '10%',

        //marginLeft: 40,
        minWidth: 50,

        [mediaCSS.desktopLM]: {
            marginLeft: 20,
            width: '15%',
            [mediaCSS.desktopLM]: {
                width: '10%',
            },
        },
    },
    content: {
        // marginLeft: 40,
        // width: 60,

        [mediaCSS.desktopLM]: {
            marginLeft: 20,
        },

        img: {
            maxWidth: '100%',
            maxHeight: '100%',
        },
    },
    tableDisplay: {
        width: '100%',

        td: {
            //border: '1px solid black',
            verticalAlign: 'middle',
            padding: '10px 14px',
        },
    },
    widthFull: {
        width: '100%',
    },
    scrollWrapper: {
        overflowY: 'hidden',
        overflowX: 'auto',
        width: '100%',
    },
    changeButtonsWrapper: {
        width: 50,
        position: 'relative',
    },
    changeButtons: {
        display: 'flex',
        position: 'absolute',
        right: 14,
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0,
        transition: 'opacity 0.3s',

        '& >div': {
            marginLeft: 10,
        },
    },
    unit() {
        const self = this

        return {
            position: 'relative',
            //display: 'flex',
            alignItems: 'center',
            borderTop: `1px solid ${colors.grey}`,
            padding: 14,
            height: 70,
            overflow: 'hidden',
            lineHeight: 1.2,
            '&:hover': {
                [`& .${self.changeButtons}`]: {
                    opacity: 1,
                },
            },

            [mediaCSS.tab]: {
                paddingRight: 66,
            },
        }
    },
    searchBar: {
        display: 'flex',
        height: 40,
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
        marginBottom: 14,
    },
    search: {
        position: 'relative',
        width: '85%',

        [mediaCSS.tab]: {
            width: '70%',
        },
    },
    dropdown: {
        width: '15%',

        [mediaCSS.tab]: {
            width: '30%',
        },
    },
    searchInput: {
        border: 'none',
    },
    dropdownBtn: {
        button: {
            border: 'none',
            borderRadius: '0 !important',
            borderLeft: `1px solid ${colors.grey}`,
            background: 'none',
        },
    },
    checkboxItem: {
        backgroundColor: 'red',
    },
    deleteConfirmWrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    deleteConfirm: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '340px',
        transform: 'translate(-50%, -50%)',
        background: colors.white,
        textAlign: 'center',
        padding: 34,
        borderRadius: 20,
    },
    controls: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '24px auto 0 auto',
        maxWidth: 210,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        width: 100,
    },
    contentImg: {
        display: 'block',
        maxWidth: 50,
        maxHeight: 50,
    },
    active: {
        background: colors.warning,
    },
    error: {
        background: colors.notificationRed,
    },
}

addStyles(DSNotificationsStyles)
export default DSNotificationsStyles
